export default __webpack_public_path__ + "static/media/short_light.3ea9bfb2.svg";